import React from 'react'
import { NotificationActionTypes, NotificationTypes } from './notificationReducer'

interface INotification {
  message: string
  timeout: number
  timeLife: number
  colorMessage: string
  close: boolean
  classes?: {
    Messages__short_black: boolean
    Messages__short: boolean
    Messages__short_red: boolean
    Messages__short_yellow: boolean
    Messages__short_green: boolean
    Messages__short_blue: boolean
  }
}

export type Notification = INotification

export const notificationPush = (
  dispatch: React.Dispatch<NotificationActionTypes>,
  state: Notification[] = [],
  message: string, timeout: number, timeLife: number, colorMessage: string, close: boolean): void => {
  const newState = state

  if (newState.length > 2) {
    newState.shift()
  }

  newState.push({
    message,
    timeout,
    timeLife,
    colorMessage,
    close
  } as Notification)

  dispatch(notificationUpdate(newState))
}

export const notificationUpdate = (notifications: Notification[]): { type: NotificationTypes.NOTIFICATION_UPDATE, notifications: Notification[] } => {
  return {
    type: NotificationTypes.NOTIFICATION_UPDATE,
    notifications
  }
}
